<template>
    <div class="roomTrends">
        <public-title showBack>{{discountId?'编辑':'添加'}}房态信息</public-title>
        <div class="bg-white p-4">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="表格模式" name="first" class="text-left">
                    <div>
                        <el-select v-model="timestyle" placeholder="请选择" size="small" class="mt-5" style="width:120px" @change="showTable = false">
                            <el-option label="时间段" value="1" />
                            <el-option label="时间多选" value="2" />
                        </el-select>
                        <el-date-picker
                            v-show="timestyle == 1"
                            v-model="timelimits"
                            :picker-options="pickerOptions"
                            type="daterange"
                            size="small"
                            class="ml-3"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" />
                        <el-date-picker
                            v-show="timestyle == 2"
                            v-model="timesingles"
                            :picker-options="pickerOptions"
                            type="dates"
                            size="small"
                            class="ml-3"
                            style="width:350px"
                            value-format="yyyy-MM-dd" />
                        <el-button type="primary" size="small" class="ml-5" @click="productTable">生成表格</el-button>
                    </div>
                    <el-table
                        :data="tableData"
                        border
                        class="text-center"
                        style="width: 485px;margin-top:20px">
                        <el-table-column prop="type" label="房型" />
                        <el-table-column prop="num" label="余房数量">
                            <template slot-scope="scope">
                                <!-- <el-input-number v-model="scope.row.num" :precision="0" :min="0" :max="9999" label="请输入余量" /><div class="el-input-group__append">间</div> -->
                                <el-input placeholder="余房数量" v-model="scope.row.num" maxlength="4"><template slot="append">间</template></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="团队单价">
                            <template slot-scope="scope">
                                <!-- <el-input-number v-model="scope.row.price" :precision="2" :min="0" :max="9999999" label="请输入团价" /><div class="el-input-group__append">元</div> -->
                                <el-input placeholder="团队价格" v-model="scope.row.price" maxlength="7"><template slot="append">元</template></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="counts">
                        <p>余房数量只能输入1~10000之间的正整数</p>
                        <div>团队价格只能输入10~100000之间的正整数或小数</div>
                    </div>
                    <div v-if="queryCon.edit && !showTable && Detail.info && queryCon.type == 1" class="text-center">
                        <ul class="list-head mt-3"><li class="w-50" v-for="item in typeArr" :key="item">{{item}}</li></ul>
                        <ul>
                            <li v-for="(item, index) in Detail.info.room_start_info" :key="index" class="linetype">
                                <span>
                                    {{item.years}}
                                    <font v-if="Number(item.years.substring(0,2)) < month">
                                        <i class="text-danger" v-if="getMyDay1(year1 + item.years) == '周五'">(周五)</i>
                                        <i class="text-danger" v-if="getMyDay1(year1 + item.years) == '周六'">(周六)</i>
                                    </font>
                                    <font v-else>
                                        <i class="text-danger" v-if="getMyDay1(year + item.years) == '周五'">(周五)</i>
                                        <i class="text-danger" v-if="getMyDay1(year + item.years) == '周六'">(周六)</i>
                                    </font>
                                </span>
                                <span v-for="(v, index) in 3" :key="index">
                                    <label v-if="index == 0">
                                        <label v-if="item.data[0].room_type == 1">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                    </label>
                                    <label v-if="index == 1">
                                        <label v-if="item.data[1] && item.data[1].room_type == 2">{{item.data[1].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[1].price}}</i>）</label>
                                        <label v-if="item.data[0].room_type == 2">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                    </label>
                                    <label v-if="index == 2">
                                        <label v-if="item.data[0].room_type == 3">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                        <label v-if="item.data[1] && item.data[1].room_type == 3">{{item.data[1].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[1].price}}</i>）</label>
                                        <label v-if="item.data[2] && item.data[2].room_type == 3">{{item.data[2].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[2].price}}</i>）</label>
                                    </label>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="mt-4" v-if="showTable">
                        <h4>房态表格：</h4>
                        <el-table
                            :data="roomTypeData"
                            border
                            class="text-center edit"
                            style="width:90%!important;margin-top:20px">
                            <el-table-column label="日期" width="140">
                                <template slot-scope="scope">
                                    {{scope.row.date}}
                                    <span class="text-danger" v-if="getMyDay(new Date(scope.row.date)) == '周五' || getMyDay(new Date(scope.row.date)) == '周六'">(周末)</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="大床房(余房-团价)">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.editing">
                                        <el-input class="mr-2" size="small" maxlength="4" v-model="scope.row.dtotal"><template slot="append">间</template></el-input>
                                        <el-input  size="small" maxlength="7" v-model="scope.row.dprice"><template slot="append">元</template></el-input>
                                    </div>
                                    <div v-else>
                                        <div v-if="scope.row.dtotal && scope.row.dprice">{{scope.row.dtotal}}间（<span class="text-info">&yen;{{scope.row.dprice}}</span>）</div>
                                        <div v-else>-</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="标准间(余房-团价)">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.editing">
                                        <el-input class="mr-2" size="small" maxlength="4" v-model="scope.row.btotal"><template slot="append">间</template></el-input>
                                        <el-input  size="small" maxlength="7" v-model="scope.row.bprice"><template slot="append">元</template></el-input>
                                    </div>
                                    <div v-else>
                                        <div v-if="scope.row.btotal && scope.row.bprice">{{scope.row.btotal}}间（<span class="text-info">&yen;{{scope.row.bprice}}</span>）</div>
                                        <div v-else>-</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="三人间(余房-团价)">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.editing">
                                        <el-input class="mr-2" size="small" maxlength="4" v-model="scope.row.stotal"><template slot="append">间</template></el-input>
                                        <el-input  size="small" maxlength="7" v-model="scope.row.sprice"><template slot="append">元</template></el-input>
                                    </div>
                                    <div v-else>
                                        <div v-if="scope.row.stotal && scope.row.sprice">{{scope.row.stotal}}间（<span class="text-info">&yen;{{scope.row.sprice}}</span>）</div>
                                        <div v-else>-</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <span class="text-link ml-3 mr-3" v-show="!scope.row.editing"  @click="scope.row.editing=true">编辑</span>
                                    <span class="text-link ml-3 mr-3" v-show="scope.row.editing"  @click="rowSave(scope.row.dtotal,scope.row.btotal,scope.row.stotal,scope.row.dprice,scope.row.bprice,scope.row.sprice,scope.$index)">保存</span>
                                    <span class="text-link" @click="roomTypeData.splice(scope.$index, 1)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" v-if="!queryCon.edit" class="mt-5 mb-3 ml-auto mr-auto block" @click="submitTable">提交</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="文字模式" name="second">
                    <el-input type="textarea" :rows="10" class="mt-5" placeholder="如：6月、7月每天余房标间35间，价格280元，含早..." v-model="textarea" />
                    <el-button type="primary" v-if="!queryCon.edit" class="mt-5 mb-3" @click="submitText">提交</el-button>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-button class="mt-5" v-if="queryCon.edit" type="primary" @click="save">保存</el-button>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import qs from 'qs'
export default {
   name: 'addEditRM',
   data () {
       return {
            activeName: 'first',
            textarea: '',
            timestyle: '1',
            timelimits: '',
            timesingles: '',
            tableData: [
                {id: 1, type: '大床房', num: '', price: ''},
                {id: 2, type: '标准间', num: '', price: ''},
                {id: 3, type: '三人间', num: '', price: ''}
            ],
            roomTypeData: [],
            showTable: false,
            dataAll: [],
            datearr: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime()  < Date.now() - 86400000;
                },
            },
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear() + '-',
            year1: new Date().getFullYear() + 1 + '-',
            typeArr: ['日期', '大床房', '标准间', '三人间'],
            Detail: {},
            show: false
       }
   },
   computed: {
       ...mapState(['userLoginMessage']),
       ...mapGetters(['storeInfo','isGroup']),
       queryCon() { return this.$route.query },
        discountId () {
            return this.$route.query.discount
        },
        storeinfo () {
            return {
                store_title: this.isGroup ? this.queryCon.storeTitle : this.userLoginMessage.verifys.title,
                store_id: this.isGroup ? this.queryCon.storeId : this.storeInfo.storeId,
                store_type: this.storeInfo.type,
            }
        }
   },
   created () {
       if (this.queryCon.edit) this.getDetail()
       if (this.queryCon.type == '2') this.activeName = 'second'
   },
    methods: {
        //判断时间是星期几
        getMyDay1(date){
            date = new Date(date)
            let week;
            if(date.getDay()==0) week="周日"
            if(date.getDay()==1) week="周一"
            if(date.getDay()==2) week="周二"
            if(date.getDay()==3) week="周三"
            if(date.getDay()==4) week="周四"
            if(date.getDay()==5) week="周五"
            if(date.getDay()==6) week="周六"
            return week;
        },
        //输入框里只能输入正整数
        oninput(e) { // 通过正则过滤小数点后两位 
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null 
        },
        check (value,pri,edit) {
            let regFull =  /^([1-9]{1}|[1-9]{1}\d{1,3})$/
            let price = /^[1-9]\d{1,4}(\.\d{1,2})?$/
            if (value || pri) {
                if (!regFull.test(value)) {this.$message.error('余房数量只能输入1~10000之间的正整数')}
                if (!price.test(pri)) {this.$message.error('团队价格只能输入10~100000之间的正整数或小数')}
                if (!regFull.test(value) || !price.test(pri)) this.roomTypeData[edit].editing = true
                else this.roomTypeData[edit].editing = false
            }
        },
        //编辑时校验
        rowSave (y1,y2,y3,p1,p2,p3,edit) {
            this.check(y1,p1,edit)
            this.check(y2,p2,edit)
            this.check(y3,p3,edit)
        },
        // 校验生成表格的数据是否符合
        validateForm() {
            let regFull =  /^([1-9]{1}|[1-9]{1}\d{1,3})$/;
            let price = /^[1-9]\d{1,4}(\.\d{1,2})?$/;
            let n = 0
            let Data = this.tableData
            let ps = document.querySelector('.counts p')
            let divs = document.querySelector('.counts div')
            ps.style.display = 'none'; ps.style.color = "#000"
            divs.style.display = 'none'; divs.style.color = "#000"
            for (let v=0; v<Data.length; v++) {
                if (Data[v].num != '' && !Data[v].num.match(regFull)) {
                    ps.style.display = "block"; ps.style.color = "red"; ps.style.marginTop= 70 + (65*v) + 'px'
                    return {code:false}
                }
                if (Data[v].price != '' && !Data[v].price.match(price)) {
                    divs.style.display = "block"; divs.style.color = "red"; divs.style.marginTop= 70 + (65*v) + 'px'
                    return {code:false}
                }
                if (!Data[v].num.match(regFull) &&  Data[v].price != '') {
                    ps.style.display = "block"; ps.style.color = "red"; ps.style.marginTop= 70 + (65*v) + 'px'
                    return {code:false}
                }
                if (!Data[v].price.match(price) && Data[v].num != '') {
                    divs.style.display = "block"; divs.style.color = "red"; divs.style.marginTop= 70 + (65*v) + 'px'
                    return {code:false}
                }
                if (Data[v].num == '' && Data[v].price == '') { n+=Data[v].id }
                if (n == 6) {this.$message.error('请输入至少一组数据');return {code: false}}
            }
            return {code:true,msg:'验证通过'}
        },
        //生成表格
        productTable () {
            let result = this.validateForm();
            if (result.code) {           
                let date1,date2,start,end
                switch (this.timestyle) {
                    case '1':
                        if (!this.timelimits) {
                            this.$message.warning('请先选择日期');return
                        } else {
                            date1 = new Date(this.timelimits[0])
                            date2 = new Date(this.timelimits[1])
                            start = date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate()
                            end = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()
                            this.getYearAndMonthAndDay(start, end)
                            this.roomTypeData = this.dateAll
                        }
                        break;
                    default:
                        if (!this.timesingles) {
                            this.$message.warning('请先选择日期');return
                        } else {
                            let singles = this.timesingles.map( item => {
                                return {
                                    date: item, dtotal: this.tableData[0].num, dprice: this.tableData[0].price,
                                    btotal: this.tableData[1].num, bprice: this.tableData[1].price,editing: false,
                                    stotal: this.tableData[2].num, sprice: this.tableData[2].price
                                }
                            })
                            this.roomTypeData = singles
                        }
                        break;
                }
                this.showTable = true
            }
        },
        //判断时间是星期几
        getMyDay(date){
            let week;
            if(date.getDay()==0) week="周日"
            if(date.getDay()==1) week="周一"
            if(date.getDay()==2) week="周二"
            if(date.getDay()==3) week="周三"
            if(date.getDay()==4) week="周四"
            if(date.getDay()==5) week="周五"
            if(date.getDay()==6) week="周六"
            return week;
        },
        //获取时间范围内的所有日期
        getYearAndMonthAndDay(start,end){
            var date_all=[],i=0;
            var startTime = this.getDate(start);
            var endTime = this.getDate(end);
            while((endTime.getTime()-startTime.getTime())>=0){
                var year = startTime.getFullYear();
                var month = (startTime.getMonth() + 1).toString().length == 1 ? "0" + (startTime.getMonth()+1).toString() : (startTime.getMonth() + 1).toString();
                var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
                date_all[i]=year + "-" + month + "-" + day;
                startTime.setDate(startTime.getDate() + 1);
                i+=1;
            }
            this.datearr = date_all
            this.dateAll = date_all.map((item,index) => {
                return {
                    date: item, dtotal: this.tableData[0].num, dprice: this.tableData[0].price,
                    btotal: this.tableData[1].num, bprice: this.tableData[1].price,editing: false,
                    stotal: this.tableData[2].num, sprice: this.tableData[2].price
                }
            });
        },
        getDate (datestr) {
            var temp = datestr.split("-");
            if (temp[1] === '01') {
                temp[0] = parseInt(temp[0],10) - 1;
                temp[1] = '12';
            } else {
                temp[1] = parseInt(temp[1],10) - 1;
            }
            //new Date()的月份入参实际都是当前值-1
            var date = new Date(temp[0], temp[1], temp[2]);
            return date;
        },
        //如果编辑状态获取页面详情
        async getDetail () {
            let resData = await this.$axios.post('pc/Hotel/getRoomStateDetails', {
                store_id: this.queryCon.store_id,
                store_type: this.queryCon.store_type,
                room_state_id: this.queryCon.id
            })
            if (resData.code === '00000') {
                this.Detail = resData
                if (this.queryCon.type == 2 && this.queryCon.edit) {
                    this.textarea = this.Detail.info.room_start_info.remarks
                }
            }
        },
        //酒店编辑房态
        async save () {
            if (this.activeName == 'first' && this.showTable) { this.submitTable() }
            else if (this.activeName == 'second') { this.submitText() }
            else {
                let times = [],
                    roomObj = [],
                    arr = [];
                for (let key in this.Detail.info.room_start_info) { arr.push(this.Detail.info.room_start_info[key]) }
                for (let key in arr) {
                    times.push(arr[key].years)
                    arr[key].data.date = arr[key].years
                    for (let m in arr[key].data) {
                        roomObj.push(arr[key].data[m])
                    }
                }
                let room_arr = roomObj.map((v, index) => {
                    return {
                        date: v.date,
                        room_type: v.room_type,
                        price: Number(v.price),
                        num: Number(v.num),
                    }
                })
                room_arr = room_arr.filter(v => {return v.date})
                // 校验参数

                let data = {
                    store_title: this.Detail.info.hotel_info.title,
                    store_id: this.queryCon.store_id,
                    store_type: this.queryCon.store_type,
                    room_state_id: this.queryCon.id,
                    date: times.join(','),
                    room_arr,
                    remarks: ''
                }
                let res = await this.$axios.post('/pc/Hotel/editRoomState',data);
                if (res.code === '00000') {
                    this._alert('保存成功', () => this.$router.push({name: 'RoomTypeManage'}))
                }
            }
        },
        //文字模式提交
        async submitText () {
           if (!this.textarea) {this.$message.warning('请输入相关信息');return}
           let url = 'pc/Hotel/setRoomState'
           if (this.queryCon.edit) {
               url = 'pc/Hotel/editRoomState'
               this.storeinfo.room_state_id = this.queryCon.id
            }
            let resData = await this.$axios.post(url, {
                ...this.storeinfo,
                remarks: this.textarea
            })
            if (resData.code === '00000') {
                if (!this.queryCon.edit) {
                    this.$alert('客服人员正在将您的房态信息推送给采购商用户...', '房态信息已提交！', {
                        confirmButtonText: '确定',
                        type: 'success',
                        center: true
                    }).then(_ => {
                        this.$router.push({name: 'RoomTypeManage'})
                        this.$message({
                            showClose: true,
                            customClass: 'activeSty',
                            center: true,
                            message: '活跃值+50',
                            type: 'success'
                        });
                    })
                } else {
                    this._alert('保存成功', () => this.$router.push({name: 'RoomTypeManage'}))
                }
            }
        },
        //表格模式提交
        async submitTable () {
            if (this.timestyle == 1) {
                this.datearr = this.datearr.map(v => v.substring(5))
            } else {
                this.datearr = this.timesingles.map(v => v.substring(5))
            }
            let arrObj = []
            let arr=this.roomTypeData.map((v,index) => {
                let filterdata;
                filterdata = {id: index, date:v.date, type: 1, price: v.dprice, num: v.dtotal, edit: v.editing};
                arrObj.push(filterdata)
                filterdata = {id: index, date:v.date, type: 2, price: v.bprice, num: v.btotal, edit: v.editing};
                arrObj.push(filterdata)
                filterdata = {id: index, date:v.date, type: 3, price: v.sprice, num: v.stotal, edit: v.editing}
                arrObj.push(filterdata)
            })
            for (let i =0; i< arrObj.length; i++) {
                if (arrObj[i].edit == true) {this.$message.error('请先保存编辑项'); return}
            }
            let roomArr = arrObj.map((v, index) => {
                return {
                    date: v.date.substring(5),
                    room_type: v.type,
                    price: v.price,
                    num: v.num,
                }
            })
            let url = 'pc/Hotel/setRoomState'
            if (this.queryCon.edit) {
                url = 'pc/Hotel/editRoomState'
                this.storeinfo.room_state_id = this.queryCon.id
            }
            let resData = await this.$axios.post(url, {
                ...this.storeinfo,
                date: this.datearr.join(','),
                room_arr: roomArr,
            })
            if (resData.code === '00000') {
                if (!this.queryCon.edit) {
                    this.$alert('客服人员正在将您的房态信息推送给采购商用户...', '房态信息已提交！', {
                        confirmButtonText: '确定',
                        type: 'success',
                        center: true
                    }).then(_ => {
                        this.$router.push({name: 'RoomTypeManage'})
                        this.$message({
                            showClose: true,
                            customClass: 'activeSty',
                            center: true,
                            message: '活跃值+50',
                            type: 'success'
                        });
                    })
                } else {
                    this._alert('保存成功', () => this.$router.push({name: 'RoomTypeManage'}))
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.edit{
    .el-input{
        width: 45%;
        vertical-align: middle;
        .el-input__inner{
            padding-left: 8px;
            padding-right: 8px
        }
    }
}
.el-table{
    display: inline-block;
    margin-right: 15px
}
.linetype{
    span{
        width: 25%;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        border-right: 1px solid #e5e5e5;
        box-sizing: border-box;
        border-bottom: 1px solid #e5e5e5;
        vertical-align: middle;
        &:first-child{
            border-left: 1px solid #e5e5e5;
        }
    }
    .el-input{
        width: 35%
    }
}
.counts{
    display: inline-block;
    vertical-align: top;
    p,div{
        line-height: 65px;
        margin-top: 30px;
        display: none
    }
}
</style>
